import {useState, FC} from 'react';
import {v4 as uuidv4} from 'uuid';
import {useTranslation} from 'react-i18next';
import {GridSelectorModalWindow} from '../../../../components/modalWindows/GridSelectorModalWindow';
import {IEntitySimpleDTO} from '../../../../libs/coreapi-dto/@types/common';
import { GosContractItemsPluginSettings } from '../pluginSettings/gosContractItemsPluginSettings';
import { GosContractGoodsGrid } from '../grids/GosContractGoodsGrid';

interface IExtendedGridProps extends IGridSelectorModalProps {
    idGosContractGlobal: string;
    idGoodsGlobal: string
    message:string
}

export const GosContractGoodsSelectorModal: FC<IExtendedGridProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? ({} as IEntitySimpleDTO));
    const gridId = uuidv4();
    const plugin = GosContractItemsPluginSettings;
    const {t} = useTranslation();
    
    return (
        <GridSelectorModalWindow
            onlyGridDisplayName={props.message}
            entityToPressEnter={entity}            
            ok={{ onClick: () => props.ok?.(entity) }}
            cancel={{onClick: () => props.cancel?.()}}
        >
          {
            plugin 
              ?
              <GosContractGoodsGrid
              baseGridFilter={props.gridFilter}
              dispatchGridFilter={props.dispatchGridFilter}
              gridId={gridId}
              plugin={plugin}
              onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })}
              onDoubleClick={(row) => {
                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName });
                props.ok?.(entity);
              }} 
              idGosContractGlobal={props.idGosContractGlobal} 
              idGoodsGlobal={props.idGoodsGlobal}/>
              : <p> {t('general.directoryNotConfigured')}</p>
          }
        </GridSelectorModalWindow>
    );
};
